import type { ComponentPropsWithoutRef, CSSProperties } from "react";

import { cx } from "../../lib/cx";
import s from "./Skeleton.module.css";

export interface SkeletonProps extends ComponentPropsWithoutRef<"span"> {
  /** Un largo CSS, idealmente un token: `"var(--s-13)"`, `"40%"`. Default: todo el ancho. */
  width?: string;
  /** Un alto CSS, idealmente un token. Default: una línea de texto. */
  height?: string;
  /** Varias líneas de texto; la última sale más corta. Ignora `height`. */
  lines?: number;
  /** `circle` para avatares. */
  shape?: "rect" | "circle";
}

/** El hueco con la forma de lo que viene. Nunca un spinner genérico. */
export function Skeleton({ width, height, lines, shape = "rect", className, style, ...rest }: SkeletonProps) {
  const vars = { "--_w": width, "--_h": height } as CSSProperties;
  if (lines && lines > 1) {
    return (
      <span className={cx(s.lineas, className)} style={{ ...vars, ...style }} aria-hidden="true" {...rest}>
        {Array.from({ length: lines }, (_, i) => (
          <span key={i} className={s.hueco} data-shape="rect" data-ultima={i === lines - 1 || undefined} />
        ))}
      </span>
    );
  }
  return (
    <span
      className={cx(s.hueco, className)}
      data-shape={shape}
      style={{ ...vars, ...style }}
      aria-hidden="true"
      {...rest}
    />
  );
}
